import { useEffect } from "react";
import { useAppSelector } from "./useAppSelector";
import { eReducerStatusBase } from "../state/reducer-model/eReducerStatusBase";
import { useAppDispatch } from "./useAppDispatch";
import { rootActions } from "../state/actions/rootActions";

export const useDashboard = () => {
    const state = useAppSelector((state) => state.dashboard);
    const {status} = state;
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (status === eReducerStatusBase.is_not_initialization || status === eReducerStatusBase.is_need_reload) {
            dispatch(rootActions.dashboard.LOAD_START(undefined));
        }
    }, [status,dispatch]);
    const setSelectedLanXet = (lanXet: number) => {
        dispatch(rootActions.dashboard.SET_SELECTED_LAN_XET(lanXet));
    };
    
    const setSelectedNamXet = (namXet: string) => {
        dispatch(rootActions.dashboard.SET_SELECTED_NAM_XET(namXet));
    };
    
    // Lọc dữ liệu theo lan_xet và nam_xet được chọn
    const filteredGraduationData = (state.selectedLanXet !== null && state.selectedNamXet !== '') 
        ? (state.dashboard.tinhTrangTotNghiepTheoNganhs || []).filter(item => 
            item.lan_xet === state.selectedLanXet && item.nam_xet === state.selectedNamXet
          )
        : [];

    return {
        ...state,
        isLoading: status === eReducerStatusBase.is_loading,
        setSelectedLanXet,
        setSelectedNamXet,
        filteredGraduationData,
    };
}
